import { SearchIcon } from "lucide-react";
import { useState } from "react";
import { useDebounce } from "react-use";
import { Input } from "../ui/input";

type SearchInputProps = {
  setSearch: (label: string) => void;
  className?: string;
};

const DEBOUNCE_DELAY = 200; // milliseconds

export const SearchInput = ({ setSearch, className }: SearchInputProps) => {
  const [value, setValue] = useState("");

  useDebounce(
    () => {
      setSearch(value);
    },
    DEBOUNCE_DELAY,
    [value],
  );

  return (
    <div
      className={`rounded-lg border border-light-gray flex items-center bg-thin-gray px-2 py-0.5 ${className ?? ""}`.trim()}
    >
      <SearchIcon className="text-light-gray" />

      <Input
        className="border-none ring-0 text-sm focus:ring-0 focus-visible:ring-0 shadow-none"
        placeholder="クイズを検索"
        onChange={(e) => setValue(e.target.value)}
        value={value}
      />
    </div>
  );
};
